var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"popup-modal",on:{"click":function($event){return _vm.dissmiss()}}},[_c('div',{ref:"dialog",staticClass:"window",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }